import { useMemo } from 'react';
import { Opportunity } from '@/types/opportunity';
import { calculateCompliance } from '@services/calculations/compliance';
import { calculateStatistics } from '@services/calculations/statistics';
import { SessionStatistics } from '@/types/session';

export function useStats(opportunities: Opportunity[]): SessionStatistics {
  return useMemo(() => {
    const stats = calculateStatistics(opportunities);
    const complianceRate = calculateCompliance(opportunities);

    return {
      ...stats,
      complianceRate,
    };
  }, [opportunities]);
}
